import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider as DatePickerLocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider";
import { PropsWithChildren } from "react";

export const LocalizationProvider = ({
  locale,
  config,
  children,
}: {
  locale: string;
  config: Record<string, any>;
} & PropsWithChildren) => {
  return (
    <DatePickerLocalizationProvider
      dateAdapter={AdapterDateFns}
      localeText={config[locale].dateFieldLocaleText}
    >
      {children}
    </DatePickerLocalizationProvider>
  );
};
